import { Button } from "@/components/ui/button";
import { DEFAULT_DATE_FORMAT } from "@/constants";
import { format } from "date-fns";
import { CalendarDays } from "lucide-react";
import { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import ProjectEndDateUpdateDialog from "./ProjectEndDateUpdateDialog";
import { ControllerRenderProps } from "react-hook-form";

interface EndDateButtonProps extends ControllerRenderProps {
  value: string;
  disabled?: boolean;
}

export default forwardRef<HTMLButtonElement, EndDateButtonProps>(
  function EndDateButton(props, ref) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const { value, ...rest } = props;

    const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      setOpen(true);
    };

    return (
      <div className="w-full overflow-hidden">
        <Button
          variant="outline"
          onClick={onClick}
          {...rest}
          ref={ref}
          className="w-full justify-start pl-3 min-w-0 flex-shrink"
        >
          <CalendarDays
            className={cn("w-4 h-4 mr-2", { "text-muted-foreground": !value })}
          />
          {value ? (
            format(value, DEFAULT_DATE_FORMAT)
          ) : (
            <span className="text-muted-foreground truncate flex-shrink">
              {t("projects.updateProjectEndDate.setEndDate")}
            </span>
          )}
        </Button>
        <ProjectEndDateUpdateDialog
          open={open}
          onOpenChange={setOpen}
          value={value}
        />
      </div>
    );
  },
);
